import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Page } from 'tesseract.js';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient) { }
  toggleDailyOffer(stockId: number): Observable<any> {
    return this.http.post(
      `${environment.Server_URL}/stocks/${stockId}/toggle-daily-offer`,
      {}
    );
  }
  getWarehouseStocks(
    warehouseId: number,
    page: number,
    filters?: { categoryId?: number | null; pet?: number | null; perPage?: number }
  ): Observable<any> {

    const params: any = {
      warehouse_id: warehouseId,
      page: page,
      per_page: filters?.perPage ?? 10
    };

    if (filters?.pet !== null && filters?.pet !== undefined) {
      params.pet = filters.pet;
    }

    if (filters?.categoryId !== null && filters?.categoryId !== undefined) {
      params.category_id = filters.categoryId;
    }

    return this.http.get(
      `${environment.Server_URL}/stocks/filter`,
      { params }
    );
  }
  getAllItems(): Observable<any> {
    return this.http.get(environment.Server_URL + '/index/stocks');
  }
  editUser(id: any, Data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/update/user/${id}`, Data);
  }
  paymentRequest(id: any): Observable<any> {

    return this.http.get(environment.Server_URL + '/update/reuested/' + id);
  }
  getOneItem(id: string): Observable<any> {
    return this.http.get(environment.Server_URL + '/show/stock/' + id);
  }
  delete(id: string): Observable<any> {
    return this.http.delete(environment.Server_URL + '/delete/stock/' + id);
  }
  getAllUsers(): Observable<any> {
    return this.http.get(environment.Server_URL + '/index/users');
  }
  deleteUser(id: string): Observable<any> {
    return this.http.delete(environment.Server_URL + '/delete/user/' + id);
  }
  getAllOrders(): Observable<any> {
    return this.http.get(environment.Server_URL + '/orders');
  }
  getOrderByUserId(id: string, page: any): Observable<any> {
    return this.http.get(environment.Server_URL + '/orderuser/' + id + `?page=${page}`);
  }
  deleteOrder(id: string): Observable<any> {
    return this.http.delete(environment.Server_URL + '/orders/' + id);
  }

  changeStatus(id: any, status: any, reason: any): Observable<any> {
    const body = new FormData();
    body.append('order_status', status);
    body.append('reason', reason);
    return this.http.post(`${environment.Server_URL}/updatestatus/` + id, body);
  }
  getStock(perpage: any, page: any): Observable<any> {
    const body = new FormData();
    body.append('per_page', perpage);
    return this.http.post(`${environment.Server_URL}/get/pag?page=${page}`, body);
  }
  updateQty(status: any, orderid: any): Observable<any> {
    const body = new FormData();
    body.append('order_status', status);
    body.append('order_id', orderid);
    return this.http.post(`${environment.Server_URL}/orders/reject`, body);
  }

  updateQtyFromStock(id: any, qty: any): Observable<any> {
    const body = new FormData();
    body.append('quantity', qty);
    return this.http.post(`${environment.Server_URL}/update/quantity/` + id, body);
  }
  searchStock(serachkey: any): Observable<any> {
    const body = new FormData();
    body.append('name_ar', serachkey);
    return this.http.post(`${environment.Server_URL}/stocks/search`, body);
  }
  getoneWareHouse(id: any, Page: any): Observable<any> {
    const body = new FormData();
    body.append('warehouse_id', id);
    body.append('page', Page);

    return this.http.post(`${environment.Server_URL}/warehouses/stocks`, body);
  }
  searchByNameAndWarehouse(query: string, warehouse_id: number): Observable<any> {
    const payload = { query, warehouse_id };
    return this.http.post<any>(
      `${environment.Server_URL}/stocks/search-by-name-warehouse`,
      payload
    );
  }


  updateStockImage(stockId: number, imageFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('image', imageFile);

    return this.http.post(`${environment.Server_URL}/stocks/${stockId}/update-image`, formData);
  }
  getStocksByWarehouse(warehouseId: number, page: number, perPage: number = 10): Observable<any> {
    return this.http.get(
      `${environment.Server_URL}/stocks/warehouse?warehouse_id=${warehouseId}&page=${page}&per_page=${perPage}`
    );
  }
  getSimpleStockByWarehouse(warehouseId: number): Observable<any> {
    const payload = { warehouse_id: warehouseId };
    return this.http.post<any>(
      `${environment.Server_URL}/stocks/simple-by-warehouse`,
      payload
    );
  }

getUsersByWarehouse(
  warehouseId: number | string,
  page: number = 1,
  perPage: number = 10,
  type?: string | number | null
): Observable<any> {
  const params: any = {
    page: String(page),
    per_page: String(perPage),
  };

  if (type !== null && type !== undefined && type !== '') {
    params.type = String(type);
  }

  return this.http.get<any>(
    `${environment.Server_URL}/warehouse/${warehouseId}/users`,
    { params }
  );
}
searchUsersByWarehouse(
  warehouseId: number | string,
  page: number = 1,
  perPage: number = 10,
  filters?: {
    search?: string | null;
    name?: string | null;
    phone?: string | null;
    type?: string | number | null;
  }
): Observable<any> {
  const params: any = {
    page: String(page),
    per_page: String(perPage),
  };

  if (filters?.search) {
    params.search = filters.search;
  }

  if (filters?.name) {
    params.name = filters.name;
  }

  if (filters?.phone) {
    params.phone = filters.phone;
  }

  if (
    filters?.type !== null &&
    filters?.type !== undefined &&
    filters?.type !== ''
  ) {
    params.type = String(filters.type);
  }

  return this.http.get<any>(
    `${environment.Server_URL}/warehouses/${warehouseId}/users/search`,
    { params }
  );
}
getOrdersTotalsByDate(filters: {
  warehouse_id: number | string;
  day?: number | string | null;
  month?: number | string | null;
  year?: number | string | null;
}): Observable<any> {
  const params: any = {
    warehouse_id: String(filters.warehouse_id),
  };

  if (filters.day !== null && filters.day !== undefined && filters.day !== '') {
    params.day = String(filters.day);
  }

  if (filters.month !== null && filters.month !== undefined && filters.month !== '') {
    params.month = String(filters.month);
  }

  if (filters.year !== null && filters.year !== undefined && filters.year !== '') {
    params.year = String(filters.year);
  }

  return this.http.get<any>(
    `${environment.Server_URL}/orders/totals-by-date`,
    { params }
  );
}
}
